import React from 'react';
import { Section, Field } from './ui/formkit';

function CorpInfo({ corp, onChange }) {
  return (
    <div>
      <Section title="Corporation" description="Identity and operational status.">
        <Field label="Name" span={2} required>
          <input type="text" name="name" value={corp.name || ''} onChange={onChange} placeholder="e.g. Acme Corp" required />
        </Field>
        <Field label="Status">
          <select name="status" value={corp.status || ''} onChange={onChange}>
            <option value="">Select status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
            <option value="Onboarding">Onboarding</option>
          </select>
        </Field>
        <Field label="Start date">
          <input type="date" name="startDate" value={corp.startDate || ''} onChange={onChange} />
        </Field>
        <Field label="Website" span={2}>
          <input type="url" name="website" value={corp.website || ''} onChange={onChange} placeholder="https://example.com" />
        </Field>
      </Section>

      <Section title="Admin login" description="Optionally create the first admin account for this corporation. They receive an email invite to set their password, then sign in with this email.">
        <Field label="Admin email" span={2}>
          <input
            type="email"
            name="adminEmail"
            value={corp.adminEmail || ''}
            onChange={onChange}
            placeholder="e.g. admin@acme.com (leave empty to skip)"
          />
        </Field>
      </Section>

      <Section title="Address" description="Used on invoices and contracts.">
        <Field label="Street" span={2}>
          <input type="text" name="address" value={corp.address || ''} onChange={onChange} placeholder="Street address" />
        </Field>
        <Field label="City">
          <input type="text" name="city" value={corp.city || ''} onChange={onChange} />
        </Field>
        <Field label="State">
          <input type="text" name="state" value={corp.state || ''} onChange={onChange} />
        </Field>
        <Field label="ZIP">
          <input type="text" name="zip" value={corp.zip || ''} onChange={onChange} />
        </Field>
        <Field label="Country">
          <input type="text" name="country" value={corp.country || ''} onChange={onChange} placeholder="e.g. United States" />
        </Field>
      </Section>
    </div>
  );
}

export default CorpInfo;
